import { render, staticRenderFns } from "./erm_board.vue?vue&type=template&id=0c9cf880&scoped=true&"
import script from "./erm_board.vue?vue&type=script&lang=js&"
export * from "./erm_board.vue?vue&type=script&lang=js&"
import style0 from "./erm_board.vue?vue&type=style&index=0&id=0c9cf880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9cf880",
  null
  
)

export default component.exports